import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLayoutDashboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconLayoutDashboard"><Path d="M3 9V3H11.25V9H3Z" fill="currentColor"/><Path d="M3 10.5V21L11.25 21V10.5H3Z" fill="currentColor"/><Path d="M12.75 21L21 21V15H12.75V21Z" fill="currentColor"/><Path d="M21 13.5V3H12.75V13.5H21Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLayoutDashboard;
